/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';
import {
    NAVIGATION,
    NAVIGATION_MOBILE,
} from 'app/core/navigation/navigation.data';

/**
 * The menu now lives in `app/core/navigation/navigation.data.ts` and is served
 * by NavigationService without an HTTP round trip.
 *
 * These re-exports exist only so the Fuse mock-api handlers that still read the
 * menu — search, chiefly — keep compiling against a single definition instead
 * of a stale copy. They go away with the rest of mock-api.
 */
export const defaultNavigation: FuseNavigationItem[] = NAVIGATION;
export const compactNavigation: FuseNavigationItem[] = NAVIGATION;
export const futuristicNavigation: FuseNavigationItem[] = NAVIGATION;
export const horizontalNavigation: FuseNavigationItem[] = NAVIGATION_MOBILE;
